import React, {useState} from 'react';
import { classNames } from '../../../Services/helpers';
import Icon from '../../Icons/Icon';

const Tabs = ({children, selected, onChange, compact}) => {

  const [selectedTab, setSelectedTab] = useState(selected ?? children[0]?.props?.id ?? children[0]?.props?.title);

  const changeTab = (s) => {
    setSelectedTab(s);
    onChange && onChange(s);
  }

  return <div>
    <div>
      <div className="hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 focus:border-brand focus:ring-brand"
          defaultValue={children.find((tab) => tab.props.title === selected)?.title}
          onChange={(e) => changeTab(e.target.value)}
        >
          {children.map((tab) => (
            <option key={tab.props.title}>{tab.props.title}</option>
          ))}
        </select>
      </div>

      <div className="block">
        <div className="border-b border-gray-200 overflow-x-auto overflow-y-visible pb-px">
          <nav className="-mb-px flex" aria-label="Tabs">
            {children.map((tab) => (
              <button
                key={tab.props.title}
                onClick={(e) => { e.preventDefault(); changeTab((tab.props.id ?? tab.props.title)); }}
                className={classNames(
                  (tab.props.id ?? tab.props.title) === selectedTab
                    ? 'border-brand text-brand'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 ',
                  'group inline-flex items-center justify-center border-b-2 text-sm font-medium grow text-nowrap',
                  compact ? 'py-2' : 'py-4 px-2'
                )}
                aria-current={(tab.props.id ?? tab.props.title) === selectedTab ? 'page' : undefined}
              >
                {tab.props.icon && <Icon icon={tab.props.icon}
                  size="0.5x"
                  badge={tab.props.iconBadge}
                  className={classNames(
                    (tab.props.id ?? tab.props.title) === selectedTab ? 'fill-brand' : 'fill-gray-400 group-hover:fill-gray-500',
                    '-ml-0.5 mr-3'
                  )}
                  aria-hidden="true"
                />}
                <span>
                  {tab.props.title}
                  {tab.props.badge}
                </span>
              </button>
            ))}
          </nav>
        </div>
      </div>
    </div>
    {children.map((child) => {
      if ((child.props.id ?? child.props.title) !== selectedTab) {
        return null;
      }

      return child;
    })}
  </div>
}

const Tab = ({children, compact}) => {
  return <div className={classNames('relative', compact ? 'py-2' : 'py-6' )}>{children}</div>
}

export default Tabs;

export {
  Tab
};
